import { connect } from 'react-redux';
import { compose, lifecycle, withHandlers, branch, renderComponent } from 'recompose';
import { isPristine } from 'redux-form';
import { injectIntl } from 'react-intl';
import { isEmpty, get } from 'lodash';

import requestsStatuses from 'modules/common/constants/requestsStatuses';
import { replaceTo } from 'modules/auth/actions/redirectAction';
import { checkExternalInitialization } from 'shared/utils/externalLoginUtils';
import { renderByPermission } from 'modules/common/hocs/renderByPermission';
import NoPermissionsPlaceholder from 'modules/common/components/NoPermissionsPlaceholder';
import { AppointmentsFetchPendingPlaceholder } from 'modules/queues/common/components';
import { fetchAppointmentById } from 'modules/queues/Schedule/actions/fetchAppointmentById';
import { getCurrentAppointment } from 'modules/appointmentInfo/selectors/currentAppointment';
import { isCurrentAppointmentArchived } from 'modules/appointmentInfo/selectors/mediaGallery';
import { openArchive } from 'modules/queues/Archive/actions/archive';
import { hideAppointmentInfo } from 'modules/queues/common/actions/appointmentInfo';
import { UPDATE_APPOINTMENT_FORM } from '../../constants/formTypes';
import { invokeUpdateAppointmentDiscardModal } from '../../actions/invokeModals';

import EditAppointment from './EditAppointment';

const mapStateToProps = (state) => {
  return {
    isPristine: isPristine(UPDATE_APPOINTMENT_FORM)(state),
    isExternalInit: checkExternalInitialization(),
    appointmentRequestStatus: state.appointmentInfo.currentAppointment.requestStatus,
    isClosedAppointment: isCurrentAppointmentArchived(state),
    hasOrgConfig: !isEmpty(get(state, 'common.organizationConfig.generalConfig')),
    isArchiveOpened: state.queues.common.appointmentInfo.isArchiveOpened,
    appointment: getCurrentAppointment(state),
    fetchedAppointmentId: state.queues.common.appointmentInfo.appointmentId,
  };
};

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  invokeUpdateAppointmentDiscardModal: (...props) => dispatch(invokeUpdateAppointmentDiscardModal(...props)),
  fetchAppointmentById: (id) => dispatch(fetchAppointmentById(id, undefined, true)),
  openArchive: () => dispatch(openArchive()),
  hideAppointmentInfo: () => dispatch(hideAppointmentInfo()),
});

const Container = compose(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onCancel: ({
      isClosedAppointment,
      isPristine,
      invokeUpdateAppointmentDiscardModal,
      fetchedAppointmentId,
      appointment,
      hideAppointmentInfo,
    }) => () => {
      let cbLink = '/appointments';
      let cb = () => replaceTo(cbLink);

      if (fetchedAppointmentId && fetchedAppointmentId !== appointment.appointmentId) {
        cbLink += '?list=true';
        cb = () => {
          hideAppointmentInfo();
          replaceTo(cbLink);
        };
      }
      if (isPristine || isClosedAppointment) return cb();

      invokeUpdateAppointmentDiscardModal(cb);
    },
  }),
  lifecycle({
    componentDidMount() {
      if (!this.props.appointmentId) return;

      this.props.fetchAppointmentById(this.props.appointmentId);
    },
    componentDidUpdate(prevProps) {
      if (!prevProps.appointment.appointmentId && this.props.appointment.appointmentId) {
        if (this.props.isClosedAppointment && !this.props.isArchiveOpened) {
          this.props.openArchive();
        }
      }
    },
  }),
  branch(
    ({ appointmentRequestStatus, hasOrgConfig }) => appointmentRequestStatus !== requestsStatuses.success || !hasOrgConfig,
    renderComponent(AppointmentsFetchPendingPlaceholder),
  ),
)(EditAppointment);

export default renderByPermission(['APPOINTMENTS.update'])(Container, NoPermissionsPlaceholder);
